import React, { useEffect, useState} from 'react';
import OtpField from './OtpField';

const VerificationPartial = (props) => {
  const [state, setState] = useState({
    showOtpError: false,
    errorMessage: '',
    resendOtpEnabled: true,
  });

  const [ emailOtp, setEmailOtp ] = useState('');
  const [ mobileOtp, setMobileOtp ] = useState('');
  useEffect(() => {
    if (props.getOtpResponse.error) {
      setState({
        ...state,
        errorMessage: 'You have sent too many OTP requests for this username.',
        resendOtpEnabled: false,
      })
    }
    if (props.verifyOtpResponse.error) {
      setState({
        ...state,
        errorMessage: props.verifyOtpResponse.error,
      });
    } else if (props.verifyOtpResponse.status) {
      props.completeVerification();
    }

  }, [props]);

  const verify = () => {
    if (mobileOtp && emailOtp) {
      props.verifyOtp(props.userName, 'B', { emailCode: emailOtp, smsCode: mobileOtp });
    } else {
      setState({ ...state, showOtpError: true });
    }
  };

  const changeEmailOtp = (value) => {
    setEmailOtp(value);
  };

  const changeMobileOtp = (value) => {
    setMobileOtp(value);
  };

  const getEmailOtp = () => {
    if (state.resendOtpEnabled) {
     props.getOtp(props.userName, 'E');
    }
  };

  const getMobileOtp = () => {
    if (state.resendOtpEnabled) {
      props.getOtp(props.userName, 'M');
    }
  };

    const { email, mobileNumber } = props;
    const { errorMessage, showOtpError } = state;
    return (
      <div className="makeFlex column hrtlCenter appendTop80">
        <div className="textCenter appendBottom40">
          <p className="accountCreatedSuccessIcon"/>
          <p className="font24 latoBold blackText appendBottom10">
            IRCTC account created
          </p>
          <p className="defaultGreyText appendBottom10">
            Please verify your email address and mobile number
          </p>
          <p className="font12 defaultGreyText">
            Check your email inbox and SMS app for OTPs from IRCTC
          </p>
        </div>
        {
          errorMessage &&
          <p className="unignoredError appendBottom10 font14 redText makeFlex column ">
            <span className="latoBold">{errorMessage}</span>
          </p>
        }
        <div className="otpSection">
          <OtpField
            value={emailOtp}
            label={'Enter OTP received on email address'}
            error={showOtpError && emailOtp}
            errorMsg={errorMessage || 'Please Enter OTP'}
            resendOtpText="Resend Email address OTP in"
            placeholder={`6-digit OTP received on ${email}`}
            resendText="Resend OTP to email"
            changeValue={changeEmailOtp}
            getOtp={getEmailOtp}
          />
          <OtpField
            value={mobileOtp}
            label={'Enter OTP received on mobile number'}
            error={showOtpError && mobileOtp}
            errorMsg={errorMessage || 'Please Enter OTP'}
            resendOtpText="Resend Mobile Number OTP in"
            placeholder={`6-digit OTP received on +91 ${mobileNumber}`}
            resendText="Resend OTP to mobile"
            changeValue={changeMobileOtp}
            getOtp={getMobileOtp}
          />
          <p className="latoBlack verifyLink"><a onClick={verify}>verify</a></p>
        </div>
      </div>
    );
  }

// VerificationPartial.propTypes = {
//   getOtp: PropTypes.func,
//   verifyOtp: PropTypes.func,
//   otpErrorMessage: PropTypes.string,
//   showOtpError: PropTypes.bool,
//   userName: PropTypes.string,
// };

export default VerificationPartial;
